export const scrapeMatcherPalette = {
  primary: {
    main: '#4a90d9',
    light: '#9dd4f7',
    lighter: '#e4f2fc'
  },
  secondary: {
    light: '#e6e6fa',
    lighter: '#d8bfd8',
    main: '#ba55d3',
    dark: '#8a2be2',
    darken: '#4b0082'
  },
  disabled: {
    light: '#c0c0c0'
  },
  warning: {
    light: '#fcc937',
    lighter: '#fdde82'
  },
  success: {
    light: '#5db975',
    lighter: '#85cb98'
  },
  error: {
    light: '#ee695d',
    lighter: '#f5a19a'
  },
}

// --- Restyling: dataseekers web-aligned colors (consumed via @palette) ---
export const dsColorNew = {
  navy:          '#0C1A3E',   // sidebar background
  appBlue:       '#4a90d9',   // icons, sidebar active state
  appBlueHover:  '#3d7bc4',   // sidebar active hover
  webBlue500:    '#2563EB',   // CTAs, chevrons, card hover borders
  webBlueHover:  '#1549CC',   // CTA hover (gradient start)
  cyan:          '#06B6D4',   // button gradient end
  cyanHover:     '#0591B2',   // button hover gradient end
  grayBorder:    '#E5E7EB',   // subtle borders (cards, popovers)
  hoverBgLight:  '#F0F4FF',   // popover item hover
  textDark:      '#374151',   // popover text
  contentBg:     '#F5F7FA',   // general content area background
  filterInputBg: '#F9FAFB',   // filter input background
  // login gradient stops
  loginGrad1:    '#0a1e38',
  loginGrad2:    '#122f54',
  loginGrad3:    '#1e5a8f',
  loginGrad4:    '#3a7fd4',
}